// @ts-nocheck
import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  InputNumber,
  Row,
  Spin,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { CreateService, Service, get } from '../../../../api';
import { Contact, CreateContact } from '../../../../api/models/contacts';

type TaxesFormProps = {
  type: string;
  id?: number | null;
  add: (v: CreateContact) => void;
  update: (v: Contact) => void;
};

const TaxesForm: React.FC<TaxesFormProps> = (props) => {
  const { type, id, add, update } = props;
  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);

  //ENDPOINTS
  const { isLoading: isLoadingContact, data } = useQuery<Service>([type], () =>
    id ? get<Service>('/taxes/' + id).then((e) => e.data) : ''
  );

  useEffect(() => {
    if (data && type !== 'add' && id && !isLoadingContact) {
      form.setFieldsValue({
        description: data?.description,
        percent: data?.percent,
      });
    }
  }, [form, data, id, type, isLoadingContact]);

  const addServiceFunction = async (values: any) => {
    setIsSubmitting(true);
    if (type === 'add') {
      // AGREGAR SERVICIO
      let contactRequest: CreateService = {
        description: values.description,
        percent: values.percent,
      };
      add(contactRequest);
    } else {
      // EDITAR SERVICIO
      values['id'] = id;
      update(values);
    }
  };

  return (
    <Spin
      spinning={isLoadingContact && type !== 'add'}
      tip={<p>Cargando...</p>}
    >
      <Form
        name="add-promo"
        layout="vertical"
        form={form}
        onFinish={addServiceFunction}
      >
        <Divider />
        <Row style={{ display: 'flex', justifyContent: 'center' }}>
          <Col xs={20}>
            <Row gutter={16}>
              <Col xs={12} md={12}>
                <Form.Item
                  label="Descripción:"
                  name="description"
                  rules={[
                    {
                      required: true,
                      message: 'Por favor ingrese una descripción.',
                    },
                  ]}
                >
                  <Input
                    placeholder="Ingresa información"
                    disabled={type === 'watch'}
                  />
                </Form.Item>
              </Col>
              <Col xs={12} md={12}>
                <Form.Item
                  label="Porcentaje:"
                  name="percent"
                  rules={[
                    {
                      required: true,
                      message: 'Por favor ingrese porcentaje',
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: '100%' }}
                    disabled={type === 'watch'}
                    placeholder="Ingresa información"
                    min={1}
                    formatter={(value) =>
                      ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    }
                    parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row justify="end">
              <Form.Item>
                <Button
                  htmlType="submit"
                  className="btn-add"
                  disabled={
                    type === 'watch' || isLoadingContact || isSubmitting
                  }
                >
                  Guardar
                </Button>
              </Form.Item>
            </Row>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

export default TaxesForm;
